(function importImagesStateDefinition() {
    'use strict';
    angular.module('Entities')
        .service('importImagesStateService', [
            'restUrlBuilder', function importStateService(restUrlBuilder) {

                this.getAll = function get() {
                    return restUrlBuilder.all('states')
                        .get();
                };
            }
        ]);
})();